import React, { startTransition } from "react";
import logo from "../../assets/icons/logo.svg";
import classes from "../../styles/TermsAndPrivacy.module.scss";
import CustomImage from "../../components/core/CustomImage/CustomImage";
import { useNavigate } from "react-router";
import { APP_PATH } from "../../routes/route";
import classNames from "classnames";

function TermsOfService() {
  const navigate = useNavigate();
  const handleClick = () => {
    startTransition(() => {
      navigate(`${APP_PATH}`);
    });
  };
  return (
    <>
      <div className={classes.header}>
        <CustomImage
          src={logo}
          clickHandler={handleClick}
          height={20}
          className={classes.logo}
        />
        <div className={classes.heading}>Terms and Conditions</div>
      </div>

      <div className={classNames(classes.container, "containerWidth")}>
        <div className={classes.innerHeading}>
          Welcome to <b>Paytm Cloud Solution</b>
        </div>
        <div className={classes.content}>
          <a href="www.paytmcloudsolution.com">www.paytmcloudsolution.com</a> is
          a website owned and operated by One97 Communications Pvt. Ltd..{" "}
          <br></br>
          Before you use this site, we request you to carefully read these Terms
          and Conditions
          <br></br>
          <br></br>
          This document is an electronic record in terms of the Information
          Technology Act, 2000 and hence does not require any physical or
          digital signatures.
          <br></br>
          <br></br>
          The document has been prepared as per the provisions of the laws and
          regulations that need to be compiled and published with the privacy
          policy, rules and regulations and Terms of Use for usage of{" "}
          <b>Paytm Cloud Solution</b>.
        </div>
        <div className={classes.innerHeading}>Introduction</div>
        <div className={classes.content}>
          This Website by the URL{" "}
          <a href="www.paytmcloudsolution.com">www.paytmcloudsolution.com</a> is
          owned and operated by <b>ONE97 COMMUNICATION LIMITED</b> (HEREAFTER
          REFERRED TO AS, “COMPANY”),{" "}
          <b>
            A COMPANY INCORPORATED UNDER THE COMPANIES ACT, 1956 AND HAVING ITS
            REGISTERED OFFICE AT ,1st FLOOR, DEVIKA TOWER, NEHRU PLACE, NEW
            DELHI – 110019 AND ITS CORPORATE OFFICE AT A-80, UDHYOG MARG, A
            BLOCK, SECTOR 2, NOIDA, UTTAR PRADESH 201301 (HEREINAFTER REFERRED
            TO AS “ONE97” OR “ORGANIZER”) FOR THE ELIGIBLE RIGHTFUL SUBSCRIBERS
            OF VODAFONE IDEA LIMITED, (HEREINAFTER REFERRED TO AS “VIL/VODAFONE
            IDEA”)
          </b>
          .<br></br>
          <br></br>
          Below are our terms and conditions of use (hereinafter referred to as
          the “Agreement” or “Terms''). Usage and access to our product/services
          is subject to the acceptance of the terms of this Agreement. And thus
          you must review and accept the terms of this Agreement in order to be
          eligible to use our Product/services.
          <br></br>
          <br></br>
          The expressions “You” or “User”, used in this agreement whenever the
          context so requires, for the purposes of these Terms and Conditions,
          shall mean any natural or legal person who might create membership
          account on this Website by registration or shall agree to avail our
          services through this website, or otherwise access our Website.
          <br></br>
          <br></br>
          The expressions “We”, “Us”, “Our”, “Website” in this agreement shall
          mean <b>Paytm Cloud Solution</b> or its affiliates or agents.
        </div>
        <div className={classes.innerHeading}>Acceptance of Terms of Use</div>
        <div className={classes.content}>
          All those visiting this site to access, browse or use are bound by the
          forth mentioned Terms & Conditions (“Terms”) and shall carefully read
          and agree to these in order to continue using this website else, do
          not use this site.
        </div>
        <div className={classes.innerHeading}>Modification of Terms</div>
        <div className={classes.content}>
          The ‘Terms of Use’ for this website can be changed or updated at any
          time by <b>Paytm Cloud Solution</b> without any prior notice, in its
          sole discretion and shall be effective once posted. Your continuance
          to the usage of the website will mark your acceptance of such
          amendments. It is advisable for you to review the applicable terms and
          conditions on a regular basis . <b>Paytm Cloud Solution</b> reserves
          the right to discontinue or alter or update the website or its content
          at any time without any prior notice to you.
        </div>
        <div className={classes.innerHeading}>Privacy Notice</div>
        <div className={classes.content}>
          Personal information provided through this Website shall be used as
          per <b>Paytm Cloud Solution’s Privacy Policies</b> and these{" "}
          <b>“Terms and Conditions”</b> are subject to the Privacy Notice,
          posted on this Website.
        </div>
        <div className={classes.innerHeading}>Copyright and Trademarks</div>
        <div className={classes.content}>
          By using this website, You acknowledge that all content available on
          this Website i.e. the graphics, software, images, sounds, pictures,
          website design along with other materials and information available on
          this website with its arrangement & selection (collectively “content”)
          are the property of <b>Paytm Cloud Solution</b> or its licensors, and
          are subject to and protected by intellectual property laws and rights.
          Website reserves complete ownership, title and full intellectual
          property rights. Except as expressly authorized by these Terms and
          Conditions, You shall not use, change, copy, transmit, distribute or
          derive another work using any Content from this Website or the service
          without the prior written authorization of <b>Paytm Cloud Solution</b>{" "}
          or the respective intellectual property rights owner. The User holds
          Complete ownership, title and full intellectual property rights in all
          works/content uploaded by any User on the Website.
        </div>
        <div className={classes.innerHeading}>Privacy Notice</div>
        <div className={classes.content}>
          By using this website, You acknowledge that all content available on
          this Website i.e. the graphics, software, images, sounds, pictures,
          website design along with other materials and information available on
          this website with its arrangement & selection (collectively “content”)
          are the property of <b>Paytm Cloud Solution</b> or its licensors, and
          are subject to and protected by intellectual property laws and rights.
          Website reserves complete ownership, title and full intellectual
          property rights. Except as expressly authorized by these Terms and
          Conditions, You shall not use, change, copy, transmit, distribute or
          derive another work using any Content from this Website or the service
          without the prior written authorization of <b>Paytm Cloud Solution</b>
          or the respective intellectual property rights owner. The User holds
          Complete ownership, title and full intellectual property rights in all
          works/content uploaded by any User on the Website.
          <br></br>
          <br></br>
          The Website gives you a nonexclusive, revocable, non transferable and
          limited license to view the Content that has been retrieved from the
          Website only for your non- commercial personal use, in case You do not
          remove or mishandle any copyright notice, trademark notice or any
          other proprietary rights notices that are displayed on or in
          association with the Content. You may not use any Content available
          through the Website in any other way or for any purpose without the
          prior consent or written permission of the Website. All rights not
          expressly granted in this Terms and Conditions of this service are
          expressly reserved to Us.
          <br></br>
          <br></br>
          The Website shall at any time discontinue, modify, or suspend its
          operation of this Website, wholly or partially, temporarily or
          permanently, without any prior notice to you. You should not displace
          any trademark, copyright or other intellectual property notices
          contained in the original material from any material that has been
          printed or copied off from the website or link to this website without
          our prior written consent.
          <br></br>
          <br></br>
          <b>Paytm Cloud Solution</b> and all products & logos are trademarks or
          registered trademarks of <b>Paytm Cloud Solution</b> or its affiliates
          and thus shouldn’t be construed as or in connection with any other
          product or service which is not <b>Paytm Cloud Solution</b> product or
          service.
        </div>
        <div className={classes.innerHeading}>
          Disclaimer of Warranties, Inaccuracies or Errors:
        </div>
        <div className={classes.content}>
          <b>Paytm Cloud Solution</b> to its best, ensures that all information
          and recommendations, whether in association to the products,
          offerings, services or otherwise (hereinafter “Information”) provided
          as part of this website is correct during its inclusion on the web
          site, <b>Paytm Cloud Solution</b> does not guarantee the accuracy of
          the Information.
          <b>Paytm Cloud Solution</b> makes no representations or warranties as
          to the completeness or accuracy of Information.
          <br></br>
          <br></br>
          <b>Paytm Cloud Solution</b> does not commit to update or modify the
          information that appears on the internet or on this website. The
          information on this website is supplied upon the condition that the
          users receiving those shall make their own determination as to its
          suitability for their individual purposes prior to using or making any
          associated decision. The website contains no information inviting
          investments in <b>Paytm Cloud Solution</b> or its affiliates. Any use
          of this website and the information here shall be at your own risk and
          neither
          <b>Paytm Cloud Solution</b> and its affiliates, employees, officers or
          agents shall be in any way responsible for any sort of damage, loss or
          expense that arises out of any access to the usage of or reliance on
          this website.
          <br></br>
          <br></br>
          Nothing contained herein on the website is to be construed as a
          recommendation to use any process, product or formulation, in conflict
          with any patent or otherwise and <b>Paytm Cloud Solution</b> makes no
          representation or warranty, express or implied that, the use thereof
          shall not infringe any patent, or otherwise.
          <br></br>
          <br></br>
          THIS WEBSITE IS PROVIDED TO YOU ON AN “AS IS” AND “WHERE-IS” BASIS,
          WITHOUT ANY WARRANTY. <b>Paytm Cloud Solution</b>. FOR ITSELF AND ANY
          THIRD PARTY THAT PROVIDES MATERIALS, SERVICES, OR CONTENT TO THIS
          WEBSITE, SHALL MAKE NO REPRESENTATIONS OR WARRANTIES, EITHER EXPRESS,
          IMPLIED, STATUTORY OR OTHERWISE OF MERCHANTABILITY, FITNESS FOR A
          SPECIFIC PURPOSE, OR NON-INFRINGEMENT OF THIRD PARTY RIGHTS, WITH
          RESPECT TO THE WEBSITE, THE INFORMATION OR ANY PRODUCTS OR SERVICES TO
          WHICH THE INFORMATION REFERS. <b>Paytm Cloud Solution</b> WILL NOT BE
          LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DAMAGES OF ANY KIND, WHICH
          INCLUDES BUT IS NOT LIMITED TO, DIRECT, INDIRECT, INCIDENTAL,
          CONSEQUENTIAL OR PUNITIVE DAMAGES, THAT ARISES FROM OR IS CONNECTED
          WITH THE SITE, INCLUDING BUT NOT LIMITED TO, YOUR USAGE OF THIS SITE
          OR YOUR INABILITY TO MAKE USE OF THE SITE, EVEN IF{" "}
          <b>Paytm Cloud Solution</b> HAS PREVIOUSLY BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES.
        </div>
        <div className={classes.innerHeading}>Availability</div>
        <div className={classes.content}>
          <b>Paytm Cloud Solution</b> controls and operates this website from
          India and makes no representation for the materials to be appropriate
          for or will be available for usage in other locations. Your usage of
          this web site from outside India, shall hold you entirely responsible
          for the compliance with all applicable local laws.
        </div>
        <div className={classes.innerHeading}>
          Third Party Interaction and Links to Third Party Sites
        </div>
        <div className={classes.content}>
          There is a possibility for this website to be linked to other websites
          across the World Wide Web which is not under the control of Paytm
          Cloud Solution and is thus not maintained by the former. Such links do
          not indicate any endorsement or responsibility on the part of Paytm
          Cloud Solution for the external website concerned, the links displayed
          and its contents. The links hereby are provided only for your ease to
          help you find the relevant websites, products and/or services that
          shall interest you quickly & easily. It is the responsibility of the
          User/You to decide whether the products and/or services available via
          any of these websites are useful for your purposes. Paytm Cloud
          Solution holds no responsibility for the owners or operators of these
          websites or for any goods or services they supply for their website
          content and doesn’t enter or give any warranties, conditions or any
          other terms of representations in association to any of these or
          accepts any liability associated to any of these (including any
          liability that arises from any claim that content of the external
          website is inclusive of a link that infringes the intellectual
          property rights of any third party.
          <br></br>
          <br></br>
          At present the third party links that are being used in the website
          are forth mentioned and <b>Paytm Cloud Solution</b> may add further
          links if required in near future. The links used are inclusive of
          WordPress.com Single Sign On; WordPress.com; WordPress Stats; Google
          Analytics with anonymized IP; Amazon Web Services (AWS); Google
          Analytics for Firebase; Advertising Reporting Features; Google
          Analytics Demographics and Interests reports; Google Ad Manager;
          Google Ad Manager Audience Extension; Mobile Journey; Google Optimize
          ; Google Optimize 360; YouTube Analytics and Reporting API; Google
          Optimize ; Google Optimize 360.
        </div>
        <div className={classes.innerHeading}>General Terms & Conditions</div>
        <div className={classes.content}>
          <b>Paytm Cloud Solution</b> does not monitor your postings on the
          website on a regular basis but reserves the right to do so. However,
          in our efforts towards promoting good citizenship within the internet
          community if <b>Paytm Cloud Solution</b> comes across any
          inappropriate or unjustified usage of the website or any of its
          services, Paytm Cloud Solution shall have the right to respond in any
          way that it seeps appropriate. By your usage of this website, you
          acknowledge that Paytm Cloud Solution has the right to report to law
          enforcement authorities and that any actions shall be considered as
          illegal and the information it receives of such illegal conduct.
          <br></br>
          <br></br>
          Upon request, <b>Paytm Cloud Solution</b> will cooperate fully with
          law enforcement agencies during any investigation of alleged illegal
          activity on the Internet. Unauthorized usage of any materials present
          on this website shall violate copyright laws, trademark laws, certain
          communications statutes and regulations, the laws of privacy and
          publicity and other applicable laws and regulations. You solely are
          responsible for your actions or the actions of any person that uses
          your username and/or password. As such, you shall indemnify and hold
          <b>Paytm Cloud Solution</b> and its officers, directors, employees,
          affiliates, agents, licensors, and business partners harmless from and
          against any and all loss, costs, damages, liabilities, and expenses
          (inclusive of attorneys’ fees) incurred in association to, arising
          from, or for the purpose of avoiding, any claim or demand from a third
          party that your use of the web site or the use of the web site by any
          person who uses your username and/or password (including without
          limitation your participation in the posting areas) violates any law
          applicable or regulation, or the rights of any of the third party.
          <br></br>
          <br></br>
          <b>Paytm Cloud Solution</b> reserves the right to terminate access to
          this web site at any time and without prior notice. Further this
          limited license automatically terminates, without any notice to you,
          in case you breach any of these Terms and Conditions. Upon
          termination, You must immediately destruct any material that has been
          downloaded or printed.
          <br></br>
          <br></br>
          <b>Paytm Cloud Solution</b> shall change the terms and conditions and
          disclaimer set out above from time to time. By browsing or using this
          website, you accept that you are bound by the current terms and
          conditions of the website and disclaimer and thus you are advised to
          check these each time you revisit the website.
          <br></br>
          <br></br>
          <b>Paytm Cloud Solution</b> may change the format and content of this
          web site at any time.
          <br></br>
          <br></br>
          <b>Paytm Cloud Solution</b> shall suspend website operation for
          support or maintenance work, in order to update the content or for any
          other reason. Personal details provided to <b>Paytm Cloud Solution</b>{" "}
          through this web site will only be used in relation with our privacy
          policy. Please read the same carefully. By giving your personal
          details to us you are consenting to its use in accordance with our
          privacy policy. You further agree that <b>Paytm Cloud Solution</b> and
          its partners can contact you via promotional SMS, call, emailers,
          newsletters on the Information shared and you agree to our privacy
          policy.
        </div>
        <div className={classes.innerHeading}>Waiver</div>
        <div className={classes.content}>
          In case of any failure on our part for exercising any provision or
          right under asserted Terms and Conditions, shall not hold a waiver by
          Us of that provision or right.
        </div>
        <div className={classes.innerHeading}>
          Governing Law and Dispute Resolution
        </div>
        <div className={classes.content}>
          The present Terms and Conditions shall be governed and construed in
          relation with the laws of India, without any regard to its conflict of
          law provisions. All the disputes shall be decided by a single
          arbitrator that has been appointed by both parties mutually. In case
          the parties don’t mutually nominate an arbitrator, then the
          arbitrator’s appointment would not be governed in relation with the
          Arbitration and Conciliation Act 1996 or any of the statutory
          enactment thereby. Any arbitration must be confidential, and neither
          You nor We should disclose the existence, results of any arbitration,
          content except as required by law or for the arbitration award
          purposes; the award of which is binding on both the parties. All
          administrative fees as well as expenses of arbitration shall be
          divided equally between You and Us. In all arbitrations, every party
          shall bear their own expenses of lawyers as well as preparation. The
          seat of arbitration would be New Delhi and all proceedings shall be
          conducted in English.
        </div>
        <div className={classes.innerHeading}>Contact Information</div>
        <div className={classes.content}>
          If you have any questions or concerns in association to this Terms and
          Conditions or the Website or any information that is contained
          thereon, you may contact us by writing to us at{" "}
          <a href="mailto:et.support@paytm.com">et.support@paytm.com</a>
        </div>
      </div>
    </>
  );
}
export default TermsOfService;
